import React from 'react';
import './App.css';

function Dashboard() {
  // 1. Verificamos si hay un usuario logueado en la memoria
  const usuarioGuardado = localStorage.getItem('aspe_usuario');
  
  // Si no hay nadie logueado, lo pateamos de vuelta al login
  if (!usuarioGuardado) {
    window.location.href = '/admin';
    return null;
  }

  const usuario = JSON.parse(usuarioGuardado);

  // Función para cerrar sesión
  const cerrarSesion = () => {
    localStorage.removeItem('aspe_usuario');
    window.location.href = '/admin';
  };

  return (
    <div className="dashboard-pantalla">
      {/* --- BARRA SUPERIOR PRIVADA --- */}
      <header className="dashboard-header">
        <img src="/logo.png" alt="ASPE Logo" className="dashboard-logo" />
        <div className="dashboard-user-info">
          <span>Hola, {usuario.nombre} ({usuario.rol})</span>
          <button onClick={cerrarSesion} className="btn-salir">Cerrar Sesión</button>
        </div>
      </header>

      {/* --- CONTENIDO DE MÓDULOS --- */}
      <main className="dashboard-main">
        <h2>Panel de Control Central ERP</h2>
        <p>Seleccione un módulo operativo:</p>
        
        <div className="dashboard-grid">
          <div className="dashboard-card" onClick={() => window.location.href = '/empleados'}>👥 Gestión de Empleados</div>
          <div className="dashboard-card" onClick={() => window.location.href = '/reloj'}>⏱️ Reloj de Fichaje</div>
          <div className="dashboard-card dashboard-card-proximamente">📦 Stock y Materiales<span className="badge-proximamente">Próximamente</span></div>
          <div className="dashboard-card dashboard-card-proximamente">📝 Trazabilidad de Trabajos<span className="badge-proximamente">Próximamente</span></div>
          <div className="dashboard-card dashboard-card-proximamente">📄 Facturación y Finanzas<span className="badge-proximamente">Próximamente</span></div>
          <div className="dashboard-card" onClick={() => window.location.href = '/liquidacion'}>💰 Liquidación de Jornales</div>
          <div className="dashboard-card" onClick={() => window.location.href = '/auditoria'}>🛠️ Auditoría de Tiempos</div>
        </div>
      </main>
    </div>
  );
}

export default Dashboard;